import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from 'components/common/Typography'

function ProposalTitle({ icon, title }: { icon: IconProp; title: string }) {
  return (
    <Typography className="text-xl sm:text-2xl break-all">
      <FontAwesomeIcon icon={icon} />
      {` ${title}`}
    </Typography>
  )
}

export default ProposalTitle
